const RouterTeamComponent = () => import('@/views/RouterTeam/RouterTeamView')

export default [
    {
        path:'/RouterTeamIndex',
        name:'RouterTeamRouter',
        component:RouterTeamComponent
    }
]